import jwtDecode from "jwt-decode";
import { verify, sign } from "jsonwebtoken";
import userAxiosInstance from "./axios";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  const decoded = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

//  const handleTokenExpired = (exp) => {
//   let expiredTimer;

//   window.clearTimeout(expiredTimer);
//   const currentTime = Date.now();
//   const timeLeft = exp * 1000 - currentTime;
//   expiredTimer = window.setTimeout(() => {
//   }, timeLeft);
// };

const setSession = (accessToken, userId, userRole) => {
  if (accessToken) {
    sessionStorage.setItem("accessToken", accessToken);
    sessionStorage.setItem("userId", userId);
    sessionStorage.setItem("userRole", userRole);
    userAxiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // This function below will handle when token is expired
    // const { exp } = jwtDecode(accessToken);
    // handleTokenExpired(exp);
  } else {
    sessionStorage.removeItem("accessToken");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("userRole");
    delete userAxiosInstance.defaults.headers.common.Authorization;
  }
};

export { verify, sign, isValidToken, setSession };
